module.exports = __webpack_public_path__ + "static/media/ic-border-color.1dd5ffb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-border-color.svg
// module id = 825
// module chunks = 17